import React from 'react'; 
import './Testimonials.css';   

import { Heading } from '../../../components';
import { testiContent } from '../../../constants';

import { FaQuoteLeft, FaQuoteRight, FaStar } from 'react-icons/fa';

// import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles  
import 'swiper/css';
import 'swiper/css/pagination'; 
import 'swiper/css/navigation';



const Testimonials = () => { 
  return (
    <section className='testimonials' id='testimonials'>

      <Heading title={'testimonials'} />

      <div className='testimonial-slider'>
      <Swiper 
      // install Swiper modules
      modules={[Navigation, Pagination, Autoplay]}
      loop={true}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      navigation
      pagination={{ clickable: true }}
      >
        {
          testiContent.map((testimonial) => { 
            return (
              <SwiperSlide className='testi-item' key={testimonial.id}>

                <FaQuoteLeft className='quote-left'/> {/* Testimonial quote left icon */}
                <FaQuoteRight className='quote-right'/> {/* Testimonial quote right icon */}

                <img src={testimonial.image} alt='testimonial-pic' /> {/* Author image */}

                {/* Author Rating */}
                <div className="rating">
                  <FaStar className='star'/>
                  <FaStar className='star'/>
                  <FaStar className='star'/>
                  <FaStar className='star'/>
                  <FaStar className='star'/>
                </div>
                <p>{testimonial.content}</p> {/* Testimonial */}
                <h3>{testimonial.name}</h3> {/* Author name */}
                <span>{testimonial.title}</span> {/* Author title */}

              </SwiperSlide>
            )
          })
        }

      </Swiper>
      </div>
      
    </section>

  )
} 

export default Testimonials